import { actionTypes, miscActivity, defaultValueMisc } from '../const';

const workday = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.WORKDAY_TOGGLED_SUCCESS:
            return Object.assign({}, state, {
                workdayToggled: action.toggledState
            });
        case actionTypes.TAB_CHANGE_SUCCESS:
            return Object.assign({}, state, {
                changedTab: action.changedState
            });
        case actionTypes.DEFAULTWORKDAY_SUCCESS:
            return Object.assign({}, state, {
                defaultWorkday: action.defaultWorkday
            });
        case actionTypes.WORKDAY_LOADING:
            return Object.assign({}, state, {
                workday: {},               
                isLoading: action.isLoading
            });
        case actionTypes.POST_IN_PROGRESS:
            return Object.assign({}, state, {
                postInProgress: action.progress
            });
        case actionTypes.ERR_IN_ADD_WORKDAY:
            return Object.assign({}, state, {
                errInAddWorkday: {
                    errMsg: action.errMsg,
                    errStatus: action.errStatus
                }
            });
        case actionTypes.RESET_WORKDAY_SUCCESS:
            return Object.assign({}, state, {
                workday: action.workday,
            });
        case actionTypes.WORKDAY_SUCCESS:
            for (var act in action.workday.duty_activity) {
                action.workday.duty_activity[act]["isNew"] = false;
                action.workday.duty_activity[act]["change"] = false;
            }
            return Object.assign({}, state, {
                workday: action.workday,
                isLoading: false
            });
        case actionTypes.EDIT_SUCCESS:
            var duty_activity_id = action.duty_id;
            state.workday.activitiesEditMode = true;
            if (duty_activity_id) {
                state.workday.duty_activity[duty_activity_id]['isEdited'] = true;
            } else {
                state.workday.duty_activity.forEach(function (element) {
                    if (!element.isDeleted) {
                        element.isEditClick = true;
                    }
                }, this);
            }
            return Object.assign({}, state, {
                workday: state.workday,
                modals: state.modals
            });
        case "SET_ACTIVITYERR_SUCCESS":
            var duty_act_key = action.duty_act_key,
                activity = state.workday.duty_activity[duty_act_key];
            activity['isErr'] = action.duty_act_status;
            state.workday.latestRecords = 'Y';
            return Object.assign({}, state, {
                workday: state.workday
            });
        case actionTypes.ACTIVITY_START_CHANGING:     
            return Object.assign({}, state, {
                isLoading:true
            });
        case actionTypes.ACTIVITY_FINISHED_CHANGING:
            return Object.assign({}, state, {
                isLoading:false
            });
        case actionTypes.UPDATE_SUCCESS:
            var duty_activity_key = action.updatedActObj.duty_act_key,
                activity = state.workday.duty_activity[duty_activity_key],
                act_name = action.updatedActObj.values.refs.act_name,
                act_start_time = action.updatedActObj.values.refs.startTime,
                act_end_time = action.updatedActObj.values.refs.endTime,
                act_start_place = action.updatedActObj.values.refs.start_place,
                act_end_place = action.updatedActObj.values.refs.end_place,
                dty_act_type = action.updatedActObj.values.refs.deadhead_type,
                act_start_date = action.updatedActObj.values.refs.start_date,
                act_end_date = action.updatedActObj.values.refs.end_date,
                act_misc_time = action.updatedActObj.property == "misc_time" ? action.updatedActObj.rawTime :
                    activity['dty_adjusted_value'];
                    let starTimeUpdated, endTimeUpdated;
            if (activity.isNew) {
                activity['dty_act_name'] = act_name;
                activity['dty_act_name_updated'] = act_name;
                activity['dty_act_start_time'] = typeof act_start_time != 'string' ? act_start_time.picker.value : act_start_time;;
                activity['dty_act_end_time'] = typeof act_end_time != 'string' ? act_end_time.picker.value : act_end_time;;
                activity['dty_adjusted_value'] = act_misc_time;
                starTimeUpdated = typeof activity['dty_act_start_time'] != "string" ? activity['dty_act_start_time'].picker.value.toLowerCase() : 
                    activity['dty_act_start_time'];
                endTimeUpdated = typeof activity['dty_act_end_time'] != "string" ? activity['dty_act_end_time'].picker.value.toLowerCase() : 
                    activity['dty_act_end_time'];
            } else {
                activity['dty_act_name_updated'] = act_name;
                activity['dty_act_start_time_updated'] = typeof act_start_time != 'string' ? act_start_time.picker.value : act_start_time;
                activity['dty_act_end_time_updated'] = typeof act_end_time != 'string' ? act_end_time.picker.value : act_end_time;;
                activity['dty_adjusted_value_updated'] = act_misc_time;
                activity['isEdited'] = true;
                starTimeUpdated = typeof activity['dty_act_start_time_updated'] != "string" ? activity['dty_act_start_time_updated'].picker.value.toLowerCase() : 
                    activity['dty_act_start_time_updated'];
                endTimeUpdated = typeof activity['dty_act_end_time_updated'] != "string" ? activity['dty_act_end_time_updated'].picker.value.toLowerCase() : 
                    activity['dty_act_end_time_updated'];
            }
            let changelog = false;
            if(typeof act_start_place == 'string' && act_start_place != null)
            {
                activity['dty_act_start_place'] = act_start_place;
                changelog = true;
            }
            if(typeof act_end_place == 'string' && act_end_place != null)
            {
                activity['dty_act_end_place'] = act_end_place;
                changelog = true;
            }
            if(typeof dty_act_type == 'string' && dty_act_type != null)
            {
                activity['dty_act_type'] = dty_act_type;
                changelog = true;
            }
            if(typeof act_start_date == 'string' && act_start_date != null)
            {
                activity['dty_act_start_date'] = act_start_date;
                changelog = true;
            }
            if(typeof act_end_date == 'string' && act_end_date != null)
            {
                activity['dty_act_end_date'] = act_end_date;
                changelog = true;
            }
            if(starTimeUpdated && starTimeUpdated.toLowerCase() != activity['dty_act_start_time'].toLowerCase() || 
                endTimeUpdated && endTimeUpdated.toLowerCase() != activity['dty_act_end_time'].toLowerCase() ||
                activity['dty_act_name_updated'] && activity['dty_act_name_updated'].trim().toLowerCase() != activity['dty_act_name'].trim().toLowerCase()){
                activity['change'] = true;
            } else if(activity.isNew || changelog){
                activity['change'] = true;
            } else {
                activity['change'] = false;
            }
            if(miscActivity){
                 miscActivity.indexOf(act_name) > -1 ? activity['isMisc'] = 1 : activity['isMisc'] = 0;
                 if(act_name == 'Diversion'){
                    activity['disableMisc'] = 1;
                    activity['dty_act_start_time_updated'] = '12:00 AM';
                    activity['dty_act_end_time_updated'] = '12:00 AM';
                    activity['dty_adjusted_value'] = '2:00';
                 } else if(act_name == 'Locomotive Engineer Stipend'){
                    activity['disableMisc'] = 1;
                    activity['dty_act_start_time_updated'] = '12:00 AM';
                    activity['dty_act_end_time_updated'] = '12:00 AM';
                    activity['dty_adjusted_value'] = '1:00';
                 } else if(act_name == 'Time Paid Not Worked Overtime'){
                    activity['disableMisc'] = 0;
                    activity['dty_act_start_time_updated'] = '12:00 AM';
                    activity['dty_act_end_time_updated'] = '12:00 AM';
                    activity['dty_adjusted_value'] = act_misc_time;
                 } else{
                    activity['disableMisc'] = 0;
                    activity['dty_adjusted_value'] = '0:00';
                 }
            }
            if (action.updatedActObj.rawTime) {
                activity[action.updatedActObj.rawTime.property] = action.updatedActObj.rawTime.rawTime;
            }
            return Object.assign({}, state, {
                workday: state.workday
            });
        case actionTypes.DELETE_SUCCESS:
            var duty_activity_id = action.duty_id,
                activity = state.workday.duty_activity[duty_activity_id]
            if (activity['isEdited']) {
                activity['isEdited'] = false;
                activity['isErr'] = false;
            }
            if (activity['isNew']) {
                var duty_activities = state.workday.duty_activity;
                var index = duty_activities.indexOf(action.duty_id);
                duty_activities.splice(index, 1);
            } else {
                activity['isDeleted'] = true;
            }
            return Object.assign({}, state, {
                workday: state.workday
            });
        case actionTypes.CLEAR_WORKDAY_SUCCESS:
            return Object.assign({}, state, {
                workday: {}
            });
        case actionTypes.ADD_WORKDAY_SUCCESS:
            var addWorkdaySuccess = {};
            return Object.assign({}, state, {
                addWorkdaySuccess: {
                    success: action.success,
                    successMsg: action.successMsg
                }
            });
        case actionTypes.ADD_SUCCESS:
            let actName = action.actName && action.actName != "" ? action.actName : "";
            var newActivity = {
                dty_act_end_place: "",
                dty_act_end_time: "",
                dty_act_name: actName ? actName : "",
                dty_act_start_place: "",
                dty_act_start_time: "",
                dty_adjusted_value: "0:00",
                dty_trp_id: "",
                isNew: true,
                isErr: true,
                dty_act_end_time_raw: "",
                dty_act_start_time_raw: "",
                dty_act_start_date: state.workday.wdy_date,
                dty_act_end_date: state.workday.wdy_date
            }
            if (!state.workday) {
                var workday = {
                    duty_activity: {},
                    wdy_7dayValue: '',
                    wdy_14dayValue: '',
                    wdy_working_time_hos_adjust: '',
                    wdy_working_time_hos: '',
                    wdy_spread_adjust: '',
                    wdy_spread: ''
                }
                state.workday = workday;
            } else if (Object.keys(state.workday).length == 0) {
                var workday = {
                    duty_activity: {},
                    wdy_7dayValue: '',
                    wdy_14dayValue: '',
                    wdy_working_time_hos_adjust: '',
                    wdy_working_time_hos: '',
                    wdy_spread_adjust: '',
                    wdy_spread: ''
                }
                state.workday = workday;
            } else if (!state.workday.duty_activity) {

                state.workday.duty_activity = {};
            }
            Object.assign({}, state, {
                workday: workday
            });
            var newKey = Object.keys(state.workday.duty_activity).length;
            state.workday.duty_activity[newKey] = newActivity;
            return Object.assign({}, state, {
                workday: state.workday
            });
        case actionTypes.E_AND_D_ACTIVITIES_SUCCESS:
            return Object.assign({}, state, {
                eAndDActivities: action.activity
            });
        case actionTypes.UPDATE_WORKDAY_LOG_SUCCESS:
            state.workday[action.updatedWorkdayObj.property] = action.updatedWorkdayObj.value;
            if(action.updatedWorkdayObj.property == 'dty_act_series_14'){
                state.workday['series_14_updated'] = true;
            }
            state.workday['change'] = true;
            return Object.assign({}, state, {
                workday: state.workday
            });
        default:
            return state;
    }
}
export default workday